import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

const OMNI_EDGE_LOCATION_NODES_QUERY_KEY = 'omni-edge-location-nodes';

export const getEdgeLocationNodesQueryKey = (
  clusterId: string,
  edgeLocationId: string
) => [OMNI_EDGE_LOCATION_NODES_QUERY_KEY, clusterId, edgeLocationId] as const;

const getEdgeLocationNodesQueryOptions = ({
  clusterId,
  edgeLocationId,
  enabled,
  organizationId,
}: {
  clusterId: string;
  edgeLocationId: string;
  enabled: boolean;
  organizationId: string | undefined;
}) =>
  queryOptions({
    queryKey: getEdgeLocationNodesQueryKey(clusterId, edgeLocationId),
    queryFn: async () => {
      const { data } = await apiClient.omni.listEdgeNodes({
        organizationId: organizationId!,
        clusterId,
        edgeLocationId,
      });

      return data.items ?? [];
    },
    enabled: enabled && !!clusterId && !!edgeLocationId,
  });

export const useGetEdgeLocationNodesQuery = ({
  clusterId,
  edgeLocationId,
  enabled = true,
}: {
  clusterId: string;
  edgeLocationId: string;
  enabled?: boolean;
}) => {
  const { currentOrganization } = useOrganizations();

  const {
    data: edgeNodes,
    isLoading,
    error,
    refetch,
  } = useQuery(
    getEdgeLocationNodesQueryOptions({
      clusterId,
      edgeLocationId,
      enabled,
      organizationId: currentOrganization?.id,
    })
  );

  return {
    edgeNodes,
    isLoading,
    error,
    refetch,
  };
};
